import * as React from 'react';
import './Home.css'
import { compose } from 'redux';
import { ComponentType } from 'react';
import { withAddOrUpdateSchema } from '../hoc/withAddOrUpdateSchema';
import { withAddOrUpdateTrainedModel } from '../hoc/withAddOrUpdateTrainedModel';
import { withAddOrUpdateModelData } from '../hoc/withAddOrUpdateModelData';
import { withRunModel } from '../hoc/withRunModel';
import { withErrorMessage } from '../hoc/withErrorMessage';
import { withUploadOnnxModel } from '../hoc/withUploadOnnxModel';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { UserProviderInstance } from '../@shared/services/UserProvider';
import { NotificationModel } from '../reducers/main/mainModel';
import { setUserIsLoading, setIsAuthorized } from '../reducers/main/mainReducer';
import { onThrowAlert } from '../sagas/dataSaga/dataSagaActions';
import { setIsSubscriptionDialogOpen } from '../reducers/subscription/subscriptionReducer';
import { withCalculateMetricsModal } from '../hoc/withCalculateMetricsModal';

const Auth = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [token, setToken] = React.useState<string | null>('');

  React.useEffect(() => {
    setToken(searchParams.get('token'));
  }, [navigate, searchParams, token])

  React.useEffect(() => {
    if (token) {
      localStorage.setItem('token', token);

      navigate('/');
      dispatch(setUserIsLoading(true));
      (async () => {
        try {
          const currentUser = await UserProviderInstance.current()
          if (currentUser.status === 200) {
            dispatch(setIsAuthorized(currentUser.data));
            if(currentUser.data.licenseKey === null){
              dispatch(setIsSubscriptionDialogOpen(true));
            }
          }
          else {
            dispatch(setIsAuthorized(undefined));
            navigate('/login');
          }
        }
        catch (error) {
          dispatch(onThrowAlert({
            message: (error as Error).message,
            lifeTime: 10000
          } as NotificationModel));
        }
        finally {
          dispatch(setUserIsLoading(false));
        }
      })()
    }
  }, [dispatch, navigate, token]);

  if (token) {
    return <div className='auth'><div>Apply token...</div></div>
  }


  return <div className='auth'>
    <div>Token is not found</div>
  </div>
}

export default compose<ComponentType>(
  withErrorMessage,
  withAddOrUpdateSchema,
  withAddOrUpdateTrainedModel,
  withAddOrUpdateModelData,
  withRunModel,
  withUploadOnnxModel,
  withCalculateMetricsModal
)(Auth);
